// extracted by mini-css-extract-plugin
export var category = "update-item-module--category--7fe57";
export var image = "update-item-module--image--29c14";
export var root = "update-item-module--root--a2f3e";
export var text = "update-item-module--text--a6568";
export var title = "update-item-module--title--6fcd1";
export var white = "update-item-module--white--01599";